exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.break-protect[data-v-46b77ad0] {\n    page-break-inside: avoid;\n}\n", ""]);

// exports
